


// import React, { useEffect, useState } from "react";
// import { Pencil, Trash2, Plus, MapPin, Phone } from "lucide-react";
// import { AuthAPI } from "../api/AuthAPI";
// import DashboardLayout from "../layouts/DashboardLayout";

// export default function AddressesPage() {
//   const [addresses, setAddresses] = useState([]);
//   const [editingId, setEditingId] = useState(null);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [formError, setFormError] = useState("");
//   const [fieldErrors, setFieldErrors] = useState({});

//   const [form, setForm] = useState(emptyForm());

//   const [page, setPage] = useState(1);
//   const [pagination, setPagination] = useState(null);

//   useEffect(() => {
//     fetchAddresses();
//     // eslint-disable-next-line
//   }, [page]);

//   function emptyForm() {
//     return {
//       id: null,
//       address: "",
//       postal: "",
//       city: "",
//       phone: "",
//       state: "",
//       country: "India",
//     };
//   }

//   function resetFormState() {
//     setFormError("");
//     setFieldErrors({});
//   }

//   async function fetchAddresses() {
//     setLoading(true);

//     try {
//       const res = await AuthAPI.getaddress({
//         page,
//         limit: 10,
//       });

//       const list = Array.isArray(res?.data?.data)
//         ? res.data.data
//         : [];

//       setAddresses(list);
//       setPagination(res?.data?.settings || null);
//     } catch {
//       setAddresses([]);
//     } finally {
//       setLoading(false);
//     }
//   }

//   function startAdd() {
//     resetFormState();
//     setEditingId("new");
//     setForm(emptyForm());
//   }

//   async function startEdit(id) {
//     resetFormState();
//     setEditingId(id);
//     setSaving(true);

//     try {
//       const res = await AuthAPI.getsignleadress(id);
//       const d = res.data.data ?? res.data;

//       setForm({
//         id: d.id,
//         address: d.address || "",
//         postal: d.pincode || "",
//         city: d.city || "",
//         phone: d.phone || "",
//         state: d.state || "",
//         country: d.country || "India",
//       });
//     } finally {
//       setSaving(false);
//     }
//   }

//   function cancelEdit() {
//     setEditingId(null);
//     setForm(emptyForm());
//     resetFormState();
//   }

//   async function handlePostalChange(value) {
//     const cleaned = value.replace(/\D/g, "").slice(0, 6);

//     setForm((prev) => ({
//       ...prev,
//       postal: cleaned,
//     }));

//     setFieldErrors((prev) => ({
//       ...prev,
//       postal: "",
//     }));

//     if (cleaned.length !== 6) return;

//     try {
//       const res = await fetch(
//         `https://api.postalpincode.in/pincode/${cleaned}`
//       );

//       const data = await res.json();

//       if (data?.[0]?.Status === "Success") {
//         const po = data[0].PostOffice[0];

//         setForm((prev) => ({
//           ...prev,
//           city: po.District,
//           state: po.State,
//         }));
//       }
//     } catch {}
//   }

//   function validateForm() {
//     const errors = {};

//     if (!form.address.trim())
//       errors.address = "Address is required";

//     if (!form.postal.trim())
//       errors.postal = "Pincode is required";
//     else if (!/^[0-9]{6}$/.test(form.postal))
//       errors.postal = "Pincode must be exactly 6 digits";

//     if (!form.city.trim())
//       errors.city = "City is required";

//     if (!form.phone.trim())
//       errors.phone = "Phone is required";
//     else if (!/^[0-9]{10}$/.test(form.phone))
//       errors.phone =
//         "Phone number must be exactly 10 digits";

//     if (!form.state.trim())
//       errors.state = "State is required";

//     if (!form.country.trim())
//       errors.country = "Country is required";

//     setFieldErrors(errors);

//     return Object.keys(errors).length === 0;
//   }

//   async function saveAddress(e) {
//     e.preventDefault();

//     resetFormState();

//     if (!validateForm()) return;

//     setSaving(true);

//     const payload = {
//       address: form.address,
//       pincode: form.postal,
//       city: form.city,
//       phone: form.phone,
//       state: form.state,
//       country: form.country,
//     };

//     try {
//       if (editingId === "new") {
//         await AuthAPI.createaddress(payload);
//       } else {
//         await AuthAPI.updateaddress(form.id, payload);
//       }

//       await fetchAddresses();
//       cancelEdit();
//       setPage(1);
//     } catch (err) {
//       setFormError(
//         err?.response?.data?.message ||
//           "Failed to save address"
//       );
//     } finally {
//       setSaving(false);
//     }
//   }

//   async function removeAddress(id) {
//     if (!window.confirm("Delete this address?")) return;

//     try {
//       await AuthAPI.deleteaddress(id);

//       setAddresses((p) =>
//         p.filter((a) => a.id !== id)
//       );
//     } catch {}
//   }

//   const goNextPage = () => {
//     if (!pagination) return;
//     if (page >= pagination.total_pages) return;
//     setPage((p) => p + 1);
//   };

//   const goPrevPage = () => {
//     if (page <= 1) return;
//     setPage((p) => p - 1);
//   };

//   return (
//     <DashboardLayout>
//       <div className="max-w-6xl mx-auto p-6 space-y-8">
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//           <div>
//             <h2 className="text-3xl font-bold text-gray-900">
//               My Addresses
//             </h2>
//             <p className="text-gray-500 text-sm mt-1">
//               Manage your delivery addresses
//             </p>
//           </div>

//           <button
//             onClick={startAdd}
//             className="bg-yellow-400 hover:bg-yellow-500 px-5 py-3 rounded-xl font-semibold flex items-center gap-2 transition"
//           >
//             <Plus size={18} />
//             Add New Address
//           </button>
//         </div>

//         {editingId === "new" && (
//           <Card>
//             <AddressForm
//               form={form}
//               setForm={setForm}
//               onCancel={cancelEdit}
//               onSave={saveAddress}
//               saving={saving}
//               onPostalChange={handlePostalChange}
//               fieldErrors={fieldErrors}
//               formError={formError}
//             />
//           </Card>
//         )}

//         {loading ? (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             {[1, 2, 3].map((i) => (
//               <div
//                 key={i}
//                 className="border rounded-2xl p-6 animate-pulse"
//               >
//                 <div className="h-5 bg-gray-200 rounded w-1/3 mb-4" />
//                 <div className="h-4 bg-gray-200 rounded mb-2" />
//                 <div className="h-4 bg-gray-200 rounded mb-2" />
//                 <div className="h-4 bg-gray-200 rounded w-1/2" />
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             {addresses.map((a) => (
//               <Card key={a.id}>
//                 {editingId === a.id ? (
//                   <AddressForm
//                     form={form}
//                     setForm={setForm}
//                     onCancel={cancelEdit}
//                     onSave={saveAddress}
//                     saving={saving}
//                     onPostalChange={handlePostalChange}
//                     fieldErrors={fieldErrors}
//                     formError={formError}
//                   />
//                 ) : (
//                   <div className="flex justify-between gap-5">
//                     <div className="flex-1">
//                       <div className="flex items-center gap-2 mb-4">
//                         <MapPin
//                           size={18}
//                           className="text-yellow-500"
//                         />
//                         <h3 className="font-semibold text-lg">
//                           Delivery Address
//                         </h3>
//                       </div>

//                       <div className="space-y-2 text-sm">
//                         <div className="flex">
//                           <span className="w-20 text-gray-500">
//                             Address:
//                           </span>
//                           <span>{a.address}</span>
//                         </div>

//                         <div className="flex">
//                           <span className="w-20 text-gray-500">
//                             City:
//                           </span>
//                           <span>{a.city}</span>
//                         </div>

//                         <div className="flex">
//                           <span className="w-20 text-gray-500">
//                             State:
//                           </span>
//                           <span>{a.state}</span>
//                         </div>

//                         <div className="flex">
//                           <span className="w-20 text-gray-500">
//                             Pincode:
//                           </span>
//                           <span>{a.pincode}</span>
//                         </div>

//                         <div className="flex items-center">
//                           <span className="w-20 text-gray-500">
//                             Phone:
//                           </span>
//                           <Phone
//                             size={14}
//                             className="mr-1"
//                           />
//                           <span>{a.phone}</span>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="flex flex-col gap-2">
//                       <button
//                         onClick={() =>
//                           startEdit(a.id)
//                         }
//                         className="p-2 rounded-lg hover:bg-blue-50"
//                       >
//                         <Pencil
//                           size={18}
//                           className="text-blue-600"
//                         />
//                       </button>

//                       <button
//                         onClick={() =>
//                           removeAddress(a.id)
//                         }
//                         className="p-2 rounded-lg hover:bg-red-50"
//                       >
//                         <Trash2
//                           size={18}
//                           className="text-red-600"
//                         />
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </Card>
//             ))}
//           </div>
//         )}

//         {pagination &&
//           pagination.total_pages > 1 && (
//             <div className="flex justify-center items-center gap-5 pt-6">
//               <button
//                 onClick={goPrevPage}
//                 disabled={page <= 1}
//                 className="px-5 py-2 rounded-xl border"
//               >
//                 Prev
//               </button>

//               <span>
//                 Page {page} of{" "}
//                 {pagination.total_pages}
//               </span>

//               <button
//                 onClick={goNextPage}
//                 disabled={
//                   page >=
//                   pagination.total_pages
//                 }
//                 className="px-5 py-2 rounded-xl border"
//               >
//                 Next
//               </button>
//             </div>
//           )}
//       </div>
//     </DashboardLayout>
//   );
// }

// /* ---------- components ---------- */

// function Card({ children }) {
//   return (
//     <div className="border border-gray-200 rounded-2xl bg-white p-5 shadow-sm hover:shadow-md transition">
//       {children}
//     </div>
//   );
// }

// function AddressForm({
//   form,
//   setForm,
//   onCancel,
//   onSave,
//   saving,
//   onPostalChange,
//   fieldErrors,
//   formError,
// }) {
//   return (
//     <form onSubmit={onSave} className="space-y-6">
//       {formError && (
//         <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-xl text-sm">
//           {formError}
//         </div>
//       )}

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
//         <Field
//           label="Address"
//           value={form.address}
//           error={fieldErrors.address}
//           onChange={(v) =>
//             setForm({
//               ...form,
//               address: v,
//             })
//           }
//         />

//         <Field
//           label="Postal Code"
//           value={form.postal}
//           error={fieldErrors.postal}
//           maxLength={6}
//           onChange={onPostalChange}
//         />
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
//         <Field
//           label="City"
//           value={form.city}
//           error={fieldErrors.city}
//           onChange={(v) =>
//             setForm({
//               ...form,
//               city: v,
//             })
//           }
//         />

//         <Field
//           label="Phone"
//           value={form.phone}
//           error={fieldErrors.phone}
//           maxLength={10}
//           onChange={(v) => {
//             if (!/^\d*$/.test(v)) return;

//             setForm({
//               ...form,
//               phone: v,
//             });
//           }}
//         />
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
//         <Field
//           label="State"
//           value={form.state}
//           error={fieldErrors.state}
//           onChange={(v) =>
//             setForm({
//               ...form,
//               state: v,
//             })
//           }
//         />

//         <Field
//           label="Country"
//           value={form.country}
//           error={fieldErrors.country}
//           onChange={(v) =>
//             setForm({
//               ...form,
//               country: v,
//             })
//           }
//         />
//       </div>

//       <div className="flex justify-end gap-3">
//         <button
//           type="button"
//           onClick={onCancel}
//           className="px-5 py-3 border rounded-xl hover:bg-gray-50"
//         >
//           Cancel
//         </button>

//         <button
//           type="submit"
//           disabled={saving}
//           className="px-5 py-3 bg-yellow-400 hover:bg-yellow-500 rounded-xl font-semibold"
//         >
//           {saving
//             ? "Saving..."
//             : "Save Address"}
//         </button>
//       </div>
//     </form>
//   );
// }

// function Field({
//   label,
//   value,
//   onChange,
//   error,
//   maxLength,
// }) {
//   return (
//     <div>
//       <label className="block text-sm font-medium mb-2 text-gray-700">
//         {label}
//       </label>

//       <input
//         maxLength={maxLength}
//         className={`w-full border rounded-xl px-4 py-3 outline-none transition ${
//           error
//             ? "border-red-500"
//             : "focus:border-yellow-400"
//         }`}
//         value={value}
//         onChange={(e) =>
//           onChange(e.target.value)
//         }
//       />

//       {error && (
//         <p className="text-red-500 text-xs mt-1">
//           {error}
//         </p>
//       )}
//     </div>
//   );
// }






import React, { useEffect, useState } from "react";
import {
  Pencil,
  Trash2,
  Plus,
  MapPin,
  Phone,
  Home,
  Hash,
  Building2,
  Globe2,
  Map,
} from "lucide-react";
import Swal from "sweetalert2";
import { AuthAPI } from "../api/AuthAPI";
import DashboardLayout from "../layouts/DashboardLayout";

export default function AddressesPage() {
  const [addresses, setAddresses] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [formError, setFormError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const [form, setForm] = useState(emptyForm());

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    fetchAddresses();
    // eslint-disable-next-line
  }, [page]);

  function emptyForm() {
    return {
      id: null,
      address: "",
      postal: "",
      city: "",
      phone: "",
      state: "",
      country: "India",
    };
  }

  function resetFormState() {
    setFormError("");
    setFieldErrors({});
  }

  async function fetchAddresses() {
    setLoading(true);

    try {
      const res = await AuthAPI.getaddress({
        page,
        limit: 9,
      });

      const list = Array.isArray(res?.data?.data) ? res.data.data : [];

      setAddresses(list);
      setPagination(res?.data?.settings || null);
    } catch {
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  }

  function startAdd() {
    resetFormState();
    setEditingId("new");
    setForm(emptyForm());
  }

  async function startEdit(id) {
    resetFormState();
    setEditingId(id);
    setSaving(true);

    try {
      const res = await AuthAPI.getsignleadress(id);
      const d = res.data.data ?? res.data;

      setForm({
        id: d.id,
        address: d.address || "",
        postal: d.pincode || "",
        city: d.city || "",
        phone: d.phone || "",
        state: d.state || "",
        country: d.country || "India",
      });
    } finally {
      setSaving(false);
    }
  }

  function cancelEdit() {
    setEditingId(null);
    setForm(emptyForm());
    resetFormState();
  }

  async function handlePostalChange(value) {
    const cleaned = value.replace(/\D/g, "").slice(0, 6);

    setForm((prev) => ({
      ...prev,
      postal: cleaned,
    }));

    setFieldErrors((prev) => ({
      ...prev,
      postal: "",
    }));

    if (cleaned.length !== 6) return;

    try {
      const res = await fetch(
        `https://api.postalpincode.in/pincode/${cleaned}`,
      );

      const data = await res.json();

      if (data?.[0]?.Status === "Success") {
        const po = data[0].PostOffice[0];

        setForm((prev) => ({
          ...prev,
          city: po.District,
          state: po.State,
        }));
      }
    } catch {}
  }

  function validateForm() {
    const errors = {};

    if (!form.address.trim()) errors.address = "Address is required";

    if (!form.postal.trim()) errors.postal = "Pincode is required";
    else if (!/^[0-9]{6}$/.test(form.postal))
      errors.postal = "Pincode must be exactly 6 digits";

    if (!form.city.trim()) errors.city = "City is required";

    if (!form.phone.trim()) errors.phone = "Phone is required";
    else if (!/^[0-9]{10}$/.test(form.phone))
      errors.phone = "Phone number must be exactly 10 digits";

    if (!form.state.trim()) errors.state = "State is required";

    if (!form.country.trim()) errors.country = "Country is required";

    setFieldErrors(errors);

    return Object.keys(errors).length === 0;
  }

  async function saveAddress(e) {
    e.preventDefault();

    resetFormState();

    if (!validateForm()) return;

    setSaving(true);

    const payload = {
      address: form.address,
      pincode: form.postal,
      city: form.city,
      phone: form.phone,
      state: form.state,
      country: form.country,
    };

    try {
      if (editingId === "new") {
        await AuthAPI.createaddress(payload);
      } else {
        await AuthAPI.updateaddress(form.id, payload);
      }

      await fetchAddresses();
      cancelEdit();
      setPage(1);
    } catch (err) {
      setFormError(err?.response?.data?.message || "Failed to save address");
    } finally {
      setSaving(false);
    }
  }

  async function removeAddress(id) {
    const result = await Swal.fire({
      title: "Delete this address?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      await AuthAPI.deleteaddress(id);

      setAddresses((p) => p.filter((a) => a.id !== id));

      Swal.fire({
        title: "Deleted",
        text: "Address removed successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        title: "Failed",
        text:
          err?.response?.data?.message || "Could not delete this address.",
        icon: "error",
      });
    }
  }

  const goNextPage = () => {
    if (!pagination) return;
    if (page >= pagination.total_pages) return;
    setPage((p) => p + 1);
  };

  const goPrevPage = () => {
    if (page <= 1) return;
    setPage((p) => p - 1);
  };

  return (
    <DashboardLayout>
      <div className="max-w-6xl mx-auto p-6 space-y-8 mt-10 md:mt-0">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">My Addresses</h2>
            <p className="text-gray-500 text-sm mt-1">
              Manage your delivery addresses
            </p>
          </div>

          <button
            onClick={startAdd}
            className="bg-blue-400 hover:bg-blue-500 px-5 py-3 rounded-xl font-semibold flex items-center gap-2 transition shadow-sm"
          >
            <Plus size={18} />
            Add New Address
          </button>
        </div>

        {editingId === "new" && (
          <Card>
            <AddressForm
              form={form}
              setForm={setForm}
              onCancel={cancelEdit}
              onSave={saveAddress}
              saving={saving}
              onPostalChange={handlePostalChange}
              fieldErrors={fieldErrors}
              formError={formError}
            />
          </Card>
        )}

        {loading ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="border rounded-2xl p-6 animate-pulse">
                <div className="h-5 bg-gray-200 rounded w-1/3 mb-4" />
                <div className="h-4 bg-gray-200 rounded mb-2" />
                <div className="h-4 bg-gray-200 rounded mb-2" />
                <div className="h-4 bg-gray-200 rounded w-1/2" />
              </div>
            ))}
          </div>
        ) : addresses.length === 0 ? (
          <div className="text-center py-16 text-gray-500">
            No saved addresses yet
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {addresses.map((a) => (
              <Card key={a.id}>
                {editingId === a.id ? (
                  <AddressForm
                    form={form}
                    setForm={setForm}
                    onCancel={cancelEdit}
                    onSave={saveAddress}
                    saving={saving}
                    onPostalChange={handlePostalChange}
                    fieldErrors={fieldErrors}
                    formError={formError}
                  />
                ) : (
                  <div className="flex justify-between gap-5">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-4">
                        <span className="w-9 h-9 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                          <MapPin size={16} className="text-blue-600" />
                        </span>
                        <h3 className="font-semibold text-lg text-gray-900">
                          Delivery Address
                        </h3>
                      </div>

                     <div className="space-y-2.5 text-sm text-gray-700">
  <DetailRow icon={<Home size={14} />} label="Address" color="blue">
    {a.address}
  </DetailRow>

  <DetailRow icon={<Building2 size={14} />} label="City" color="green">
    {a.city}, {a.state}
  </DetailRow>

  <DetailRow icon={<Hash size={14} />} label="Pincode" color="amber">
    {a.pincode}
  </DetailRow>

  <DetailRow icon={<Globe2 size={14} />} label="Country" color="purple">
    {a.country}
  </DetailRow>

  <DetailRow icon={<Phone size={14} />} label="Phone" color="pink">
    {a.phone}
  </DetailRow>
</div>
                    </div>

                    <div className="flex flex-col gap-2 shrink-0 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition">
                      <button
                        onClick={() => startEdit(a.id)}
                        className="p-2 rounded-lg hover:bg-blue-50 transition"
                        title="Edit address"
                      >
                        <Pencil size={18} className="text-blue-600" />
                      </button>

                      <button
                        onClick={() => removeAddress(a.id)}
                        className="p-2 rounded-lg hover:bg-red-50 transition"
                        title="Delete address"
                      >
                        <Trash2 size={18} className="text-red-600" />
                      </button>
                    </div>
                  </div>
                )}
              </Card>
            ))}
          </div>
        )}

        {pagination && pagination.total_pages > 1 && (
          <div className="flex justify-center items-center gap-5 pt-6">
            <button
              onClick={goPrevPage}
              disabled={page <= 1}
              className={`px-5 py-2 rounded-xl border font-medium transition ${
                page > 1
                  ? "border-blue-500 text-blue-600 bg-blue-50 hover:bg-blue-500 hover:text-white"
                  : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              }`}
            >
              Prev
            </button>

            <span className="font-medium text-gray-700">
              Page {page} 
            </span>

            <button
              onClick={goNextPage}
              disabled={page >= pagination.total_pages}
              className={`px-5 py-2 rounded-xl border font-medium transition ${
                page < pagination.total_pages
                  ? "border-blue-500 text-blue-600 bg-blue-50 hover:bg-blue-500 hover:text-white"
                  : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

/* ---------- components ---------- */

function Card({ children }) {
  return (
    <div className="group border border-gray-200 rounded-2xl bg-white p-5 shadow-sm hover:shadow-md transition">
      {children}
    </div>
  );
}

function DetailRow({ icon, label, color = "blue", children }) {
  const colorMap = {
    blue: "bg-blue-50 text-blue-600",
    green: "bg-green-50 text-green-600",
    amber: "bg-amber-50 text-amber-600",
    purple: "bg-purple-50 text-purple-600",
    pink: "bg-pink-50 text-pink-600",
  };

  return (
    <div className="flex items-center gap-2.5">
      <span
        className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 ${colorMap[color]}`}
      >
        {icon}
      </span>
      <span className="text-gray-500 font-medium w-16 shrink-0">
        {label}
      </span>
      <span className="truncate text-gray-800 font-medium">{children}</span>
    </div>
  );
}

function AddressForm({
  form,
  setForm,
  onCancel,
  onSave,
  saving,
  onPostalChange,
  fieldErrors,
  formError,
}) {
  return (
    <form onSubmit={onSave} className="space-y-6">
      {formError && (
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-xl text-sm">
          {formError}
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Field
          label="Address"
          icon={<Home size={16} />}
          value={form.address}
          error={fieldErrors.address}
          onChange={(v) => setForm({ ...form, address: v })}
        />

        <Field
          label="Postal Code"
          icon={<Hash size={16} />}
          value={form.postal}
          error={fieldErrors.postal}
          maxLength={6}
          onChange={onPostalChange}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Field
          label="City"
          icon={<Building2 size={16} />}
          value={form.city}
          error={fieldErrors.city}
          onChange={(v) => setForm({ ...form, city: v })}
        />

        <Field
          label="Phone"
          icon={<Phone size={16} />}
          value={form.phone}
          error={fieldErrors.phone}
          maxLength={10}
          onChange={(v) => {
            if (!/^\d*$/.test(v)) return;
            setForm({ ...form, phone: v });
          }}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Field
          label="State"
          icon={<Map size={16} />}
          value={form.state}
          error={fieldErrors.state}
          onChange={(v) => setForm({ ...form, state: v })}
        />

        <Field
          label="Country"
          icon={<Globe2 size={16} />}
          value={form.country}
          error={fieldErrors.country}
          onChange={(v) => setForm({ ...form, country: v })}
        />
      </div>

      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-5 py-3 border rounded-xl hover:bg-gray-50 font-medium"
        >
          Cancel
        </button>

        <button
          type="submit"
          disabled={saving}
          className="px-5 py-3 bg-blue-400 hover:bg-blue-500 rounded-xl font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {saving ? "Saving..." : "Save Address"}
        </button>
      </div>
    </form>
  );
}

function Field({ label, icon, value, onChange, error, maxLength }) {
  return (
    <div>
      <label className="flex items-center gap-1.5 text-sm font-medium mb-2 text-gray-700">
        <span className="text-gray-400">{icon}</span>
        {label}
      </label>

      <div className="relative">
        <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400">
          {icon}
        </span>

        <input
          maxLength={maxLength}
          className={`w-full border rounded-xl pl-10 pr-4 py-3 outline-none transition ${
            error
              ? "border-red-500 focus:border-red-500"
              : "border-gray-200 focus:border-blue-400"
          }`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>

      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}